import { API_URL } from "config";
import Http from "util/https";
import { CSVCountCheckCsvStock, CSVUploadCheckParam, CSVUploadCountResponseApi } from "../types/index";
import { convertUTCToDate } from "../utils/common";

/**
 * 仕入先・外部倉庫用在庫一覧Api
 * @param params 在庫一覧Apiのパラメータ
 * @returns CSVCountCheckStock[]
 */
export default async function getCsvConfirmCheckApi(params: CSVUploadCheckParam) {
  const http = Http.default.alterAuth({ useToken: true });
  const url = `${API_URL}/stock/csv/confirm`;
  const res = await http.post<CSVUploadCountResponseApi>(url, params);

  const stocks: CSVCountCheckCsvStock[] = res.data.list.map((s) => {
    const stock: CSVCountCheckCsvStock = {
      productCd: s.item_cd,
      JANCd: s.jan_cd,
      amount: s.quantity,
      arrivalDate: convertUTCToDate(s.arrival_date),
      supplierCd: s.vendor_cd,
      warehouseCd: s.depot_cd,
      supplierName: s.vendor_name,
      warehouseName: s.depot_name,
      isCenter: !s.depot_kind,
      error: s.error ?? undefined,
    };
    // 仕入先の場合、倉庫コードあり
    if ('depot_cd' in s && s.depot_cd) {
      stock.warehouseCd = s.depot_cd;
      stock.warehouseName = s.depot_name;
    }

    return stock;
  });

  console.log(stocks);
  return stocks;
}
